// extracted by mini-css-extract-plugin
export default {"root":"FeedId_root__63SDO"};